import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Tool from './tool';
import { pluck, pluckNumber, pluckFontSize, getSuggestiveRotation, POSITION_TOP, POSITION_MIDDLE, POSITION_BOTTOM, convertColor } from '../../lib';
var NORMAL = 'normal',
    DEFAULT_FONT_SIZE = 10,
    DEFAULT_BORDER_PADDING = 2,
    TEXT_ALIGN_OPTIONS = {
  left: 'start',
  right: 'end',
  center: 'middle'
},
    TEXT_V_ALIGN_OPTIONS = {
  top: POSITION_TOP,
  middle: POSITION_MIDDLE,
  bottom: POSITION_BOTTOM
},
    TEXT_ROTATION_OPTIONS = {
  0: '0',
  1: '270',
  right: '90',
  cw: '90',
  left: '270',
  ccw: '270'
};

var Label =
/*#__PURE__*/
function (_Tool) {
  _inherits(Label, _Tool);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, _getPrototypeOf(Label).apply(this, arguments));
  }

  _createClass(Label, [{
    key: "__setDefaultConfig",
    value: function __setDefaultConfig() {
      _get(_getPrototypeOf(Label.prototype), "__setDefaultConfig", this).call(this);

      var a = this.config;
      a.font = 'Verdana, sans', a.rotateText = 0;
    }
  }, {
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(Label.prototype), "configureAttributes", this).call(this, a);

      var b = this,
          c = b.config;
      c.font = pluck(a.font, c.font), c.fontSize = pluckFontSize(a['font-size'], a.fontSize, DEFAULT_FONT_SIZE) * c.scale, c.fontStyle = pluck(a['font-style'], a.fontStyle, NORMAL), c.fontWeight = pluck(a['font-weight'], a.fontWeight, NORMAL), c.rotateText = pluckNumber(a.rotateText, c.rotateText), c.rotateAngle = parseFloat(TEXT_ROTATION_OPTIONS[pluck(a.rotateAngle && a.rotateAngle.toLowerCase(), '0')]);
    }
  }, {
    key: "getTextBound",
    value: function getTextBound() {
      var a = this,
          b = a.config,
          c = [];
      return b.showTextBound && (c = [convertColor(b.fill), b.borderColor, b.borderThickness, DEFAULT_BORDER_PADDING, b.radius]), c;
    }
  }, {
    key: "getLogicalSpace",
    value: function getLogicalSpace() {
      var a,
          b = this,
          c = b.getFromEnv('smartLabel'),
          _b$config = b.config,
          d = _b$config.width,
          e = _b$config.height,
          f = _b$config.marginTop,
          g = _b$config.marginLeft,
          h = _b$config.marginRight,
          i = _b$config.marginBottom;
      return a = c.getOriSize(b.config.text, !1), d = a.width, e = a.height, {
        width: d,
        height: e,
        marginTop: f,
        marginLeft: g,
        marginRight: h,
        marginBottom: i
      };
    }
  }, {
    key: "draw",
    value: function draw() {
      var a,
          b = this,
          c = b.config;
      c.text && (a = {
        x: c.x,
        y: c.y,
        text: c.text,
        fill: convertColor(c.labelFill),
        "text-bound": b.getTextBound(),
        "font-style": c.fontStyle,
        "font-weight": c.fontWeight,
        "font-family": c.font,
        "font-size": c.fontSize,
        "text-anchor": TEXT_ALIGN_OPTIONS[c.hAlign],
        "vertical-align": TEXT_V_ALIGN_OPTIONS[c.vAlign],
        transform: c.rotateText ? getSuggestiveRotation(c.rotateAngle, c.x, c.y) : 't0,0'
      }, !c.isHidden && b.addGraphicalElement({
        el: 'text',
        attr: a,
        component: b,
        container: {
          id: 'group',
          label: 'group',
          isParent: !0
        },
        label: 'text',
        id: 'label'
      }));
    }
  }]);

  return Label;
}(Tool);

export default Label;